module.exports = __webpack_public_path__ + "img/bonus_coin.cd68c9dc.svg";